import React from 'react';

type TextWithRegisteredSymbolProps = {
  children: string;
  symbol?: string;
};

/**
 * Renders text with a symbol (default: ®) extracted into a
 * styled <sup> when present. Use inside headings (h1, h2) so ® appears
 * as superscript with consistent marketing styles.
 */
export const TextWithRegisteredSymbol = ({
  children,
  symbol = '®',
}: TextWithRegisteredSymbolProps) => {
  const text = children;
  if (!text.includes(symbol)) {
    return <>{text}</>;
  }
  return (
    <>
      {text.slice(0, text.indexOf(symbol))}
      <sup className="laptop:text-[26px] desktop:text-3xl tablet:text-2xl align-super text-base">
        {symbol}
      </sup>
      {text.slice(text.indexOf(symbol) + 1)}
    </>
  );
};
